import _ from 'lodash';
import React from 'react';
import rawMarkup from '../../util/rawMarkup';
import pageTrackingConfig from '../../config/pageTracking';
import config from '../../config';

const { CONFIG_PROFILE } = config;

export default class GoogleAnalyticsScript extends React.PureComponent {

  render() {
    const env = (CONFIG_PROFILE === 'prod' || CONFIG_PROFILE === 'stage' || CONFIG_PROFILE === 'special') ? 'prod' : 'test'; 
    const trackerId = _.get(pageTrackingConfig[this.props.country], `googleAnalytics.${env}`);
    const optimizeId = _.get(pageTrackingConfig[this.props.country], `googleOptimize.${env}`);
    const requireOptimize = optimizeId ? `ga('require', '${optimizeId}');` : '';

    let googleAnalyticsInclude = `(function() {
      window.GoogleAnalyticsObject='ga';
      window.ga=window.ga||function(){(ga.q=ga.q||[]).push(arguments)};
      ga.l=+new Date;
      ga('create', '${trackerId}', 'auto');
      ${requireOptimize}
    })();`;

    if (requireOptimize) {
      googleAnalyticsInclude += `function triggerOptimize(){
        window.dataLayer=window.dataLayer||[];
        window.dataLayer.push({ event: 'optimize.activate'});
      }
        triggerOptimize();`;
    }

    return (
      <script type="text/javascript" dangerouslySetInnerHTML={rawMarkup(googleAnalyticsInclude)} />
    );
  }
}

GoogleAnalyticsScript.propTypes = {
  country: React.PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/component/Page/GoogleAnalyticsScript.jsx